"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Endpoints {
    constructor() {
        this.baseURL = 'https://www.salesmanago.com';
        this.upsertEndpoint = '/int/upsert';
        this.salesforce = '/ext/sf';
        this.registerEnv = '/account/register/env.json';
        this.phoneValidation = '/ext/validatePhone';
        this.countryData = '/ext/getCountryData';
        this.countriesList = '/ext/getCountriesList';
    }
}
exports.default = Endpoints;
